"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeUser = exports.UserRow = void 0;
const operators_1 = require("rxjs/operators");
const base_models_1 = require("./base-models");
class UserRow extends base_models_1.VasatModel {
    constructor(vasat, id) {
        super(vasat, 'UserRow', id);
        this.json = {}; // Default emtpy json field for user.
        this._modelPath = 'access/api/';
    }
    setPassword(newPassword) {
        return this.vasat.api(this.urlPath() + ".password", 'post', { newPassword: newPassword });
    }
    changePassword(oldPassword, newPassword) {
        return this.vasat.api(this.urlPath() + ".password", 'post', { oldPassword: oldPassword, newPassword: newPassword });
    }
}
exports.UserRow = UserRow;
class MeUser extends UserRow {
    fetch() {
        this.loading = this.apiObservable(this.vasat, 'get', this.urlPath(), null, { pass_error: false }).pipe((0, operators_1.map)(o => {
            return o;
        }), (0, operators_1.share)());
        return this.loading;
    }
    urlPath() {
        return '/access/me';
    }
    constructor(vasat, id) {
        super(vasat, id);
    }
}
exports.MeUser = MeUser;
